import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const icon = css`
  width: 22px;
  height: 22px;
  border: 4px solid ${colors.white.DEFAULT};
  background: ${colors.black.DEFAULT};
  box-shadow: 0px 2px 6px ${colors.black.a5};
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
`;
